import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, RefreshCw, Mail } from 'lucide-react';

const SuccessCard = ({ onReset }) => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-2xl text-center"
      >
        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-12 space-y-8">
          {/* Success Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5, type: "spring", bounce: 0.6 }}
            className="flex justify-center"
          >
            <div className="p-6 bg-green-500/20 rounded-full">
              <CheckCircle className="w-16 h-16 text-green-400" />
            </div>
          </motion.div>

          {/* Success Message */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <h2 className="text-4xl font-bold text-white mb-4">Quote Sent!</h2>
            <p className="text-xl text-gray-300 mb-2">
              Your personalized video quote is on its way
            </p>
            <div className="flex items-center justify-center space-x-2 text-amber-400">
              <Mail className="w-5 h-5" />
              <p className="text-lg">Check your email inbox</p>
            </div>
          </motion.div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
            className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-6"
          >
            <p className="text-amber-400 font-medium mb-2">What's Next?</p>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• Our team will review your requirements</li>
              <li>• You'll receive a detailed quote within 24 hours</li>
              <li>• We'll schedule a call to discuss your project</li>
            </ul>
          </motion.div>

          {/* Reset Button */}
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onReset}
            className="px-8 py-3 bg-white/10 text-white rounded-lg font-semibold hover:bg-white/20 transition-all duration-300 flex items-center space-x-2 mx-auto"
          >
            <RefreshCw className="w-5 h-5" />
            <span>Start Another Quote</span>
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default SuccessCard;